import * as React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import App from '../App/App';

const qrCodeDomain = "3.225.19.144:4277";

  // const ApiDomain = "10.206.0.74:8877"; 

// const ApiDomain = "10.110.35.11:8877"; //production
// const ApiDomainLt = "10.110.35.11:8866";

const ApiDomain = "//admin.freezecrowd.com";
const ApiUiDomain = "//admin.freezecrowd.com";
const ApiDomainLt = "172.20.0.48:8866";
const rootuipath = "//"+ApiUiDomain+"/";

const rootPathContext = "//"+ApiDomain+"/api/impulse/"
const rootPathContextLT = "//"+ApiDomainLt+"/api/impulse/"
const rootuiPathContext = "//"+ApiUiDomain+"/";


const rootpath = "//"+ApiDomain+"/api/"
const rootpathReport = "//"+ApiDomain+"/api/impulse/rpt/srv/"


function modifyPath(path) {
  const segments = path.split('/');
  const lastSegment = segments[0];
  
  if (lastSegment === 'mm' || lastSegment === 'cdr' || lastSegment === 'deal' || lastSegment === 'ratesheet' || lastSegment === 'rpt') {
    return rootPathContext + path;
  }else if(lastSegment === 'lt'){
    return rootPathContextLT + path;
  // }else if(lastSegment === 'reports'){
  //   return rootpathReport + path;
  } else {
    return rootpath + path;
  }
}
function modifyUiPath(path) {
    return rootuipath + path;  
}
function timeOut(path) {
  const segments = path.split('/');
  const lastSegment = segments[0];
  
  if (lastSegment === 'mm' || lastSegment === 'cdr' || lastSegment === 'deal' || lastSegment === 'ratesheet') {
    return false;
  }else if(lastSegment === 'lt'){
    return true;
  } else {
    return false;
  }
}

// function ResetFormData(contextJson){
//   console.log(contextJson)
//   Object.keys(contextJson).forEach((key, index) => {
//     if (key !== "xioFEConfig") {
//       contextJson[key].fields.map((field) => {
//         if(field.field_type==="hidden"){
//           if(field.field_default_value){
//             field.field_value = field.field_default_value
//             field.id = field.id;
//           }else{
//             field.field_value = field.field_value;
//             field.id = field.id;
//           }
//         }else if (field.field_default_value) {
//           field.field_value = field.field_default_value
//           field.id = ""
//         }else if(field.field_type==='nestedRender'){
//           Object.keys(field.field_context).forEach((key, index) => {
//             // ////console.log(key)
//             if (key !== "xioFEConfig") {
//               field.field_context[key].fields.map((field) => {
//                 if (field.field_default_value) {
//                   field.field_value = field.field_default_value
//                   field.id = ""
//                 }else{
//                   field.field_value = "";
//                   field.id = "";
//                 }
//               });
//             }
//           });
//         } else {
//           field.field_value = "";
//           field.field_temp_value = "";
//           field.id = "";
//         }
//         return field;
//       });
//     }
//   });
// }

//API Login 
async function APILOGIN(data, path) {
  const apiUrl = `//${ApiDomain}/api/auth/${path}`;
  let response = await axios.post(apiUrl, data)
    .then(res => {
       
      return res
    })
   
  return response.data;
}
//Api Resetpassword

async function APIREST(data, path, token) {
  const apiUrl = `//${ApiDomain}/api/auth/${path}`;

  // let token = localStorage.getItem("token");

  // Set the headers with the token
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  try {
    const response = await axios.post(apiUrl, data, { headers });
     
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function CHANGEPASSWORD(data,path, token) {
  const apiUrl = `//${rootpath}${path}`;

  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  try {
    const response = await axios.patch(apiUrl, data, { headers });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
    // if(error.response&&error.response.data){
    //   if (error.response.data.code === "INVALID_TOKEN" || error.response.data.code === "EXPIRED_TOKEN" || error.response.data.code === "EMPTY_TOKEN" ) {
    //     // if (localStorage.getItem('token')) {
    //       localStorage.removeItem('token');
    //       ReactDOM.render(<App />, document.getElementById('root'));

    //     // }
    //   }
    // }
  }
}

//download
let responseHttp;
async function APIAUTHDOWNLOAD(path) {
  let token = localStorage.getItem("token");
  let _authorization = `Bearer ${token}`;
  let authorise = false;

  var config = {
    method: 'get',
    url: modifyPath(path),
    responseType: 'blob',
    headers: {
      'token': token,
      'Authorization': _authorization,
    }
  };
  responseHttp = await axios(config)
    .then(function (_responseHttp) {
      if (_responseHttp.data) {
        responseHttp = _responseHttp.data;
        authorise = true;
      } else {
        alert('Token Expired')
      }
      return responseHttp;
    })
    .catch(function (error) {
    if(error.response&&error.response.data){
      if(error.response.data.status===500){
        alert(error.response.data.error)
      } else if(error.response.data.status===504){
        alert(error.response.data.error)
      }

      if (error.response.data.code === "INVALID_TOKEN" || error.response.data.code === "EXPIRED_TOKEN" || error.response.data.code === "EMPTY_TOKEN" ) {
          // alert('Your session token has expired. Please log in again to continue accessing the service.')
          localStorage.removeItem('token');
          ReactDOM.render(<App />, document.getElementById('root'));
      }
    }

    });

  return responseHttp;
}

//get
async function APIGET(path,ErrorMSg) {
  let response = await APIAUTHGET(path,ErrorMSg);
  return response;/** */
}


async function APIUIGET(path,ErrorMSg) {
  let token = localStorage.getItem("token");
  let _authorization = `Bearer ${token}`;
  let authorise = false;

  var config = {
    method: 'get',
    url: modifyUiPath(path),
    headers: {
      'token': token,
      'Authorization': _authorization,
      'Content-Type': 'application/json'
    }
  };
  responseHttp = await axios(config)
    .then(function (_responseHttp) {
      if (_responseHttp.data) {
        responseHttp = _responseHttp.data;
        authorise = true;
      } else {
        alert('Token Expired')
      }
      return responseHttp;
    })
    .catch(function (error) {
      if (error.code === "ERR_NETWORK" && ErrorMSg) {
        ErrorMSg('ERR_NETWORK')
        // alert('Network error: Failed to fetch data. Please check your internet connection and try again later.');
     }    
    if(error.response&&error.response.data){
      if(error.response.data.status===500 && ErrorMSg){
        ErrorMSg('ServerError')
        alert(error.response.data.error)
      } else if(error.response.data.status===504 && ErrorMSg){
        ErrorMSg('Timeout')
        // alert(error.response.data.error)
      }else{
        // alert(error.response.data.error)
      }
      if (error.response.data.code === "INVALID_TOKEN" || error.response.data.code === "EXPIRED_TOKEN" || error.response.data.code === "EMPTY_TOKEN" ) {
          // alert('Your session token has expired. Please log in again to continue accessing the service.')
          localStorage.removeItem('token');
          ReactDOM.render(<App />, document.getElementById('root'));
      }
    }

    });

  return responseHttp;
}
//Auth Get
async function APIAUTHGET(path,ErrorMSg) {
  let token = localStorage.getItem("token");
  let _authorization = `Bearer ${token}`;
  let authorise = false;

  var config = {
    method: 'get',
    url: modifyPath(path),
    headers: {
      'token': token,
      'Authorization': _authorization,
      'Content-Type': 'application/json'
    }
  };
  responseHttp = await axios(config)
    .then(function (_responseHttp) {
      if (_responseHttp.data) {
        responseHttp = _responseHttp.data;
        authorise = true;
      } else {
        alert('Token Expired')
      }
      return responseHttp;
    })
    .catch(function (error) {
      if (error.code === "ERR_NETWORK" && ErrorMSg) {
        ErrorMSg('ERR_NETWORK')
        // alert('Network error: Failed to fetch data. Please check your internet connection and try again later.');
     }    
    if(error.response&&error.response.data){
      if(error.response.data.status===500 && ErrorMSg){
        ErrorMSg('ServerError')
        alert(error.response.data.error)
      } else if(error.response.data.status===504 && ErrorMSg){
        ErrorMSg('Timeout')
        // alert(error.response.data.error)
      }else{
        // alert(error.response.data.error)
      }
      if (error.response.data.code === "INVALID_TOKEN" || error.response.data.code === "EXPIRED_TOKEN" || error.response.data.code === "EMPTY_TOKEN" ) {
          // alert('Your session token has expired. Please log in again to continue accessing the service.')
          localStorage.removeItem('token');
          ReactDOM.render(<App />, document.getElementById('root'));
      }
    }

    });

  return responseHttp;
}

//post
function APIPOST(path, data, contextJson, callback, setErrorMsg) {

  let response = APIAUTHPOST(path, data, contextJson, callback, setErrorMsg);
  // console.log(response)
  return response;
}

//Auth Post 
function APIAUTHPOST(path, _data, contextJson, callback, setErrorMsg) {
  // let {token} = React.useContext(MasterContext);
  let token = localStorage.getItem("token");
  let _authorization = `Bearer ${token}`;
  _data = JSON.stringify(_data);
  var config = {
    method: 'POST',
    // url: rootpath + path,
    timeout: timeOut(path) ? (1000 * 60 * 10) : 0,
    url: modifyPath(path),
    headers: {
      'token': token,
      'authorization': _authorization,
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "http://localhost:3000,*",
    },
    data: _data,
  }
  axios(config)
    .then(function (res) {
      let successPageJSON = {}
      let _name = "";
      Object.keys(contextJson).forEach((key, index) => {
        if (contextJson.xioFEConfig) {
          successPageJSON = Object.assign({
            "actionName": "Created",
            "flowName": _name,
            "createLink": contextJson.xioFEConfig.createLink,
            "viewLink": contextJson.xioFEConfig.viewLink,
            "createButtonText": contextJson.xioFEConfig.createButtonText,
            "viewButtonText": contextJson.xioFEConfig.viewButtonText,
            "paragraphText": contextJson.xioFEConfig.paragraphText,
            "dataRecevied": res.data

          })
        }else{
          successPageJSON = Object.assign({
            "dataRecevied": res.data
          })
        }
      })
      if (res.data && (res.data.statusCode === "Success" || res.data.statusCode === "SUCCESS")) {
        // ResetFormData(contextJson)
        callback(successPageJSON);
      } else if (res.data.statusCode === "NOT_FOUND" || res.data.statusCode === "No data is present") {
        setErrorMsg('Data Not Found','error');
        // callback(successPageJSON);
      } else if (res.data.statusCode === "Request made is not correct") {
        setErrorMsg(res.data.serverMsg,'error');
      } else if (res.data.statusCode === "NO data found to save") {
        setErrorMsg('Data Not Updated','error');
      } else if (res.data.statusCode === "SAVE_ERROR") {
        setErrorMsg(res.data.serverMsg || res.data.message,'error');
      } else {
        // Show toast message for other errors
        setErrorMsg("Something went wrong " + res.data.statusCode,'error');
      }
      return res;
    })
    .catch(function (error) {
      // console.log(error)
    if (error.response && error.response.data) {
        if(error.response.data.status===500){
          setErrorMsg(error.response.data.error,'error')
        }else if(error.response.data.status===504){
          setErrorMsg(error.response.data.error,'error')
        }
        if (
          error.response.data.code === "INVALID_TOKEN" ||
          error.response.data.code === "EXPIRED_TOKEN" ||
          error.response.data.code === "EMPTY_TOKEN"
        ) {
          // Handle token-related errors
          localStorage.removeItem('token');
          // Redirect or render your authentication component
          ReactDOM.render(<App />, document.getElementById('root'));
        }
      }
    });
}

//patch
function APIPATCH(path, data, contextJson, callback, setErrorMsg) {

  let response = APIAUTHPATCH(path, data, contextJson, callback, setErrorMsg);
  return response;

}


//Auth Patch 
function APIAUTHPATCH(path, _data, contextJson, callback, setErrorMsg) {
  // let {token} = React.useContext(MasterContext);
  let token = localStorage.getItem("token");
  let _authorization = `Bearer ${token}`;
  var config = {
    method: 'PATCH',
    // url: rootpath + path,
    url: modifyPath(path),
    headers: {
      'token': token,
      'authorization': _authorization,
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "http://localhost:3000,*",
    },
    data: _data,
  }
  axios(config)
    .then(function (res) {
      let successPageJSON = {}
      let _name = "";
      Object.keys(contextJson).forEach((key, index) => {
        // let _object = contextJson[key];
        if (index === 0) {
          _name = String(contextJson[key].page_label);
          //console.log(contextJson[key].fields[0])
        }
        //_object.fields.forEach((field, index) => {
        if (contextJson.xioFEConfig){
          successPageJSON = Object.assign({
            // "policyName":res.data.data.id,
            "flowName": _name,
            "actionName": "Edited",
            "createLink": contextJson.xioFEConfig.createLink,
            "viewLink": contextJson.xioFEConfig.viewLink,
            "createButtonText": contextJson.xioFEConfig.createButtonText,
            "viewButtonText": contextJson.xioFEConfig.viewButtonText,
            "paragraphText": contextJson.xioFEConfig.paragraphText,
            "dataRecevied": res.data

          })
        }else{
          successPageJSON = Object.assign({
            "dataRecevied": res.data
          })
        }
        // callback(successPageJSON);
      })
      // console.log(res)
      if (res.data && (res.data.statusCode === "SUCCESS" || res.data.statusCode === "Success")) {
        callback(successPageJSON);
      } else if (res.data.statusCode === "SAVE_ERROR") {
        setErrorMsg(res.data.serverMsg || res.data.message,'error');
      } else if (res.data.statusCode === "Request made is not correct") {
        if(res.data.serverMsg){
          setErrorMsg(res.data.serverMsg,'error');
        }else{
          setErrorMsg(res.data.statusCode,'error');
        }
      } else {
        setErrorMsg("Something went wrong " + res.data.statusCode,'error');
      }
      
      return res;
    })
    .catch(function (error) {
      console.log(error);
      if (error.response&&error.response.data) {
        if(error.response.data.status===500){
          setErrorMsg(error.response.data.error,'error')
        }else if(error.response.data.status===504){
          setErrorMsg(error.response.data.error,'error')
        }
        if (error.response.data.code === "INVALID_TOKEN" || error.response.data.code === "EXPIRED_TOKEN" || error.response.data.code === "EMPTY_TOKEN") {
          localStorage.removeItem('token');
          ReactDOM.render(<App />, document.getElementById('root'));
        }
      }
    });
}

//del
function APIDEL(path, data, contextJson, callback,setErrorMsg) {
   
  let response = APIAUTHDEL(path, data, contextJson, callback,setErrorMsg);
  return response;
}

function APIAUTHDEL(path, _data, contextJson, callback, setErrorMsg) {
  let token = localStorage.getItem("token");
  let _authorization = `Bearer ${token}`;
  // _data = JSON.stringify(_data);
  var config = {
    method: 'DELETE',
    // url: rootpath + path,
    url: modifyPath(path),
    headers: {
      'token': token,
      'authorization': _authorization,
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "http://localhost:3000,*",
    },
    data: _data,
  }
  axios(config)
    .then(function (res) {
      let successPageJSON = {}
      Object.keys(contextJson).forEach((key, index) => {
      
        if (contextJson.xioFEConfig) {
          successPageJSON = Object.assign({
            "actionName": "Deleted",
            "createLink": contextJson.xioFEConfig.createLink,
            "viewLink": contextJson.xioFEConfig.viewLink,
            "createButtonText": contextJson.xioFEConfig.createButtonText,
            "viewButtonText": contextJson.xioFEConfig.viewButtonText,
            "paragraphText": contextJson.xioFEConfig.paragraphText,
            "dataRecevied": res.data
          })
        }else{
          successPageJSON = Object.assign({
            "dataRecevied": res.data
          })
        }
        // callback(successPageJSON); 
      })
       
      if (res.data && res.data.statusCode === "Success") {
        callback(successPageJSON);
      } else {
        alert("Something went wrong");
      }
      return res;
    })
    .catch(function (error) {
       
      if (error.response&&error.response.data) {
        if(error.response.data.status===500){
          setErrorMsg(error.response.data.error,'error')
        }else if(error.response.data.status===504){
          setErrorMsg(error.response.data.error,'error')
        }
        if (error.response.data.code === "INVALID_TOKEN" || error.response.data.code === "EXPIRED_TOKEN" || error.response.data.code === "EMPTY_TOKEN") {
          localStorage.removeItem('token');
          ReactDOM.render(<App />, document.getElementById('root'));
        }
      }
    });
}


// function getMasterData() {
//   //peId = 'peId';
//   var masterDataJSON = [
//     { 'path': 'department', 'businessObject': 'deparment' },
//     { 'path': 'productCategory', 'businessObject': 'productCategory' },
//     { 'path': 'product', 'businessObject': 'product' }
//   ];
//   if (masterDataJSON) {
//     if (localStorage.getItem('masterData')) {
//       localStorage.removeItem('masterData');
//     }
//     let data = {};
//     masterDataJSON.map((obj) => {
//       async function settingData() {
//         return data[obj.path] = (await APIGET(obj.path + "/all").then(data => data.data))
//       }
//       settingData();
//     })
//     setTimeout(() => {
//       // if(res){
       
//       localStorage.setItem('masterData', JSON.stringify(data));
//       // localStorage.setItem(obj.businessObject,res);
//       // }
//     }, 1500)
//   }
//   return localStorage.getItem('masterData');

// }

//upload file

//Auth Post 
function APIUPLOAD(path, _data, contextJson, callback, setErrorMsg) {
  // let {token} = React.useContext(MasterContext);
  let token = localStorage.getItem("token");
  let _authorization = `Bearer ${token}`;
  // _data = JSON.stringify(_data);
  var config = {
    method: 'POST',
    url: modifyPath(path),
    headers: {
      'Content-Type': 'multipart/form-data',
      'token': token,
      'authorization': _authorization,
      "Access-Control-Allow-Origin": "http://localhost:3000,*",
    },
    // onUploadProgress: progressEvent => {
    //   setUploadPercentage(
    //     parseInt(
    //       Math.round((progressEvent.loaded * 100) / progressEvent.total)
    //     )
    //   );
    // },
    data: _data,
  }
  axios(config)
    .then(function (res) {
      let successPageJSON = {}
      let _name = "";
      Object.keys(contextJson).forEach((key, index) => {
        if (contextJson.xioFEConfig) {
          successPageJSON = Object.assign({
            "actionName": "Uploaded",
            "flowName": _name,
            "createLink": contextJson.xioFEConfig.createLink,
            "viewLink": contextJson.xioFEConfig.viewLink,
            "createButtonText": contextJson.xioFEConfig.createButtonText,
            "viewButtonText": contextJson.xioFEConfig.viewButtonText,
            "paragraphText": contextJson.xioFEConfig.paragraphText,
            "dataRecevied": res.data

          })
        }else{
          successPageJSON = Object.assign({
            "dataRecevied": res.data
          })
        }
      })
      if (res.data && (res.data.statusCode === "Success" || res.data.statusCode === "SUCCESS")) {
        callback(successPageJSON);
      } else {
        setErrorMsg("Something went wrong"+res.data.serverMsg);
      }
      // setTimeout(() => setUploadPercentage(), 2000);
      return res;
    })
    .catch(function (error) {
        if(error?.response?.data?.status===500){
          setErrorMsg(error.response.data.error)
        }else{
          alert('Something went wrong')
        }
      // setUploadPercentage()
    });
}


//

async function UNIQUECHACK(path) {
  let token = localStorage.getItem("token");
  let _authorization = `Bearer ${token}`;

  let authorise = false;

  var config = {
    method: 'get',
    url: modifyPath(path),
    headers: {
      'token': token,
      'Authorization': _authorization,
      'Content-Type': 'application/json'
    }
  };
  responseHttp = await axios(config)
    .then(function (_responseHttp) {
       
       
      if (_responseHttp.data) {
        responseHttp = _responseHttp.data;
        authorise = true;
      } else {
        alert('Token Expired')
      }
      return responseHttp;
    })
    .catch(function (error) {
       
      if (error.response.data.code === "INVALID_TOKEN" || error.response.data.code === "EXPIRED_TOKEN") {
        if (localStorage.getItem('token')) {
          localStorage.removeItem('token');
          // window.history.pushState({},"", "/");   
          ReactDOM.render(<App />, document.getElementById('root'));
          // navigate("/");

        }
      }

    });
  if (localStorage.getItem('token')) {
  } else { window.location.href("/") }
  return responseHttp;
}
export { APIGET,APIUIGET, APIPOST, APIDEL, APIPATCH, APIAUTHPOST, APILOGIN,APIREST, APIAUTHGET, APIUPLOAD, UNIQUECHACK,CHANGEPASSWORD,APIAUTHDOWNLOAD, qrCodeDomain,ApiDomain,rootpath,rootPathContext }